import {DriverJobTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class DriverJobTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in DriverJobTypeCd ) {
      this._values.push(DriverJobTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): DriverJobTypeCd {

    for ( const obj in DriverJobTypeCd ) {
      if (DriverJobTypeCd[obj] === value){
        return DriverJobTypeCd[obj] as DriverJobTypeCd;
      }
    }
  }
}

const DriverJobTypeCdHelper = new DriverJobTypeCdHelperEnumHelperClass();
export default DriverJobTypeCdHelper;
